module.exports = __webpack_public_path__ + "img/Weapon_186.d5685dee.png";